// index.js
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import DesignSystemProvider from './components/DesignSystemProvider';
import ErrorBoundary from './components/Common/ErrorBoundary';
import { AppProvider } from './AppContext';
import theme from './styles/theme';
import App from './App';
import { initAnalytics } from './analytics';

initAnalytics();

const rootElement = document.getElementById('root');

const app = (
  <ErrorBoundary>
    <DesignSystemProvider>
      <AppProvider>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </AppProvider>
    </DesignSystemProvider>
  </ErrorBoundary>
);

// hydrateRoot is used when react-snap has pre-rendered HTML into the shell.
// createRoot is used for normal client-side rendering.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
